module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Pantone-51cbf9ea64c2f5bc94b19c95fb80cbda.svg";